import { render } from "./ContentForm.vue?vue&type=template&id=380c2592&ts=true"
import script from "./ContentForm.vue?vue&type=script&lang=ts"
export * from "./ContentForm.vue?vue&type=script&lang=ts"

import "./ContentForm.vue?vue&type=style&index=0&id=380c2592&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/ContentForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "380c2592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('380c2592', __exports__)) {
    api.reload('380c2592', __exports__)
  }
  
  module.hot.accept("./ContentForm.vue?vue&type=template&id=380c2592&ts=true", () => {
    api.rerender('380c2592', render)
  })

}


export default __exports__